const STORAGE_KEY = 'onboardingPackageRequestedAt'
const EXPIRY_DAYS = 7

export const markOnboardingPackageRequested = () => {
  localStorage.setItem(STORAGE_KEY, String(Date.now()))
}

export const hasActiveOnboardingPackageRequest = () => {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return false
  }

  const requestedAt = Number(raw)
  const expiryMs = EXPIRY_DAYS * 24 * 60 * 60 * 1000

  if (!requestedAt || Date.now() - requestedAt >= expiryMs) {
    localStorage.removeItem(STORAGE_KEY)
    return false
  }

  return true
}
